import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAppSettings, updateAppSettings } from '@/lib/settings'
import type { AppSettings } from '@riverpark/types'

const KEY = ['settings']

export function useAppSettings() {
  return useQuery({ queryKey: KEY, queryFn: getAppSettings })
}

export function useUpdateAppSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (patch: Partial<AppSettings>) => updateAppSettings(patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
